import { rem, radius, token } from '@thiememeulenhoff/lit-sdk';
import { indicatorSizeMap } from '@thiememeulenhoff/types';
import { css } from 'lit';

export const indicatorStyles = css`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

  :host {
    align-items: center;
    border-radius: ${radius('extra-large')};
    color: ${token('foreground-primary')};
    display: flex;
    justify-content: center;
  }

  :host([size='small']) {
    block-size: ${rem(indicatorSizeMap.small)};
    flex-basis: ${rem(indicatorSizeMap.small)};
    font-size: ${rem(indicatorSizeMap.small - 6)};
    inline-size: ${rem(indicatorSizeMap.small)};
  }

  :host([size='medium']) {
    block-size: ${rem(indicatorSizeMap.medium)};
    flex-basis: ${rem(indicatorSizeMap.medium)};
    font-size: ${rem(indicatorSizeMap.medium - 10)};
    inline-size: ${rem(indicatorSizeMap.medium)};
  }

  :host([type='todo']),
  :host([type='empty']) {
    background-color: ${token('background-primary')};
    color: ${token('foreground-primary')};
  }

  :host([type='done']) {
    background-color: ${token('albert-indicator-done-background-default')};
    color: ${token('albert-indicator-done-foreground-default')};
  }

  :host([type='correct']) {
    background-color: ${token('albert-indicator-correct-background-default')};
    color: ${token('foreground-inverse')};
  }

  :host([type='incorrect']) {
    background-color: ${token('albert-indicator-incorrect-background-default')};
    color: ${token('foreground-inverse')};
  }

  :host([type='loading']) {
    animation: spin 2s linear infinite;
    background-color: ${token('background-primary')};
    color: ${token('foreground-tertiary')};
  }

  :host([type='predefined']) {
    color: ${token('albert-indicator-predefined-foreground-default')};
  }
`;
